import { createAsyncThunk } from '@reduxjs/toolkit'
import apiClient from '../../../services/axois'

export const getStudentCourse = createAsyncThunk('student/getStudentCourse', async (id) => {
  try {
    const url = '/student/course'
    const response = await apiClient.get(`${url}/${id}`)
    return response.data.result
  } catch (error) {
    console.error('builder function error:', error)
    throw error
  }
})
